import React from "react";
import styled from "styled-components";
import Container from "../Components/Container";
import Row from "../Components/Row";
import LogoBlue from '../assets/images/logo-blue.svg';

const Title = styled.p`
  font-size: 40px;
  font-weight: 800;
  margin-bottom: 60px;
  text-align: center;
`;

const Date = styled.p`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 60px;
`;

const Subtitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 0px;
`;

const Section = styled.div`
  p {
    font-weight: 200;
    font-size: 16px;
  }
`;

const List = styled.ul`
  list-style-type: disc;
  margin-left: 0px;
`;

const ListItem = styled.li`
  margin-bottom: 5px;
`;

const BoldText = styled.span`
  font-weight: 700;
`;

const AccountDeletionTerms = () => {
  return (
    <Container style={{ lineHeight: "35px" }}>
      <Title>Termos de Exclusão de Conta</Title>
      <Date>Última atualização: <span style={{ fontWeight: 200 }}>12/03/2025</span></Date>

      <Section>
        <p>
          Este documento estabelece as condições para a solicitação de exclusão de conta no aplicativo Room, 
          em conformidade com a <BoldText>Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018)</BoldText>, especialmente os artigos <BoldText>16 e 18</BoldText>, que tratam da retenção de dados e do direito à exclusão.
        </p>
      </Section>

      <Section>
        <Subtitle>1. Condições para Exclusão da Conta</Subtitle>
        <List>
          <ListItem>
            O usuário pode solicitar a exclusão da conta a qualquer momento através do app ou e-mail suporte@meuroom.com.br.
          </ListItem>
          <ListItem>
            A exclusão da conta removerá permanentemente os dados pessoais do usuário, salvo exceções previstas na LGPD.
          </ListItem>
          <ListItem>
            Caso o usuário não possua nenhum contrato ativo, a conta será automaticamente deletada ao solicitar a exclusão pelo app.
          </ListItem>
        </List>
      </Section>

      <Section>
        <Subtitle>2. Restrições à Exclusão de Conta</Subtitle>
        <List>
          <ListItem>
            Contas com <BoldText>contratos ativos</BoldText> não podem ser excluídas até o encerramento de todas as obrigações contratuais.
          </ListItem>
          <ListItem>
            Dados financeiros e transacionais serão mantidos pelo período exigido por lei, mesmo após a exclusão da conta.
          </ListItem>
          <ListItem>
            Se houver pendências financeiras, a solicitação de exclusão será negada até a quitação dos valores devidos.
          </ListItem>
        </List>
      </Section>

      <Section>
        <Subtitle>3. Procedimento para Solicitação</Subtitle>
        <List>
          <ListItem>
            O usuário deve enviar um e-mail para suporte@meuroom.com.br solicitando a exclusão da conta.
          </ListItem>
          <ListItem>
            Caso o usuário tenha um <BoldText>contrato ativo</BoldText>, ele deve entrar em contato com o suporte para avaliar as opções disponíveis.
          </ListItem>
          <ListItem>
            A equipe do Room responderá em até 15 dias úteis com a confirmação ou justificativa para a não exclusão.
          </ListItem>
        </List>
      </Section>

      <Section>
        <Subtitle>4. Retenção de Dados Após Exclusão</Subtitle>
        <p>
          De acordo com o <BoldText>Artigo 16 da LGPD</BoldText>, certas informações podem ser retidas mesmo após a exclusão da conta para cumprir obrigações legais, 
          como registros financeiros e históricos de transações.
        </p>
      </Section>

      <Section>
        <Subtitle>5. Contato</Subtitle>
        <p>
          Para dúvidas ou solicitações sobre a exclusão da conta, entre em contato pelo e-mail: suporte@meuroom.com.br.
        </p>
      </Section>

      <Row
        xs="1fr 1fr"
        sm="1fr 1fr"
        md="1fr 1fr"
        lg="1fr 1fr"
        xl="1fr 1fr"
        style={{ marginTop: "100px", marginBottom: '30px', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <img src={LogoBlue} width={'53px'} />
        <span style={{ fontWeight: 200, textAlign: 'right' }}>© 2024 Room</span>
      </Row>
    </Container>
  );
};

export default AccountDeletionTerms;
